import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

const useCreatePrestacionModalidadCiclica = () => {
  const [loadingCreatePrestacionModalidadCiclica, setLoadingCreatePrestacionModalidadCiclica] = useState(false);
  const [successCreatePrestacionModalidadCiclica, setSuccessCreatePrestacionModalidadCiclica] = useState(false);
  const [errorCreatePrestacionModalidadCiclica, setErrorCreatePrestacionModalidadCiclica] = useState(null);
  const [dataCreatePrestacionModalidadCiclica, setDataPrestacionModalidadCiclica] = useState(null);

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";

  const apiRecord = new record.RecordService(
    BASE_URL,
    FUNCTIONS_KEY
  );

  // CREATE
  const createPrestacionModalidadCiclica = async (
    userId: string,
    data: any,
    _cb?: (data: any) => void
  ) => {
    setLoadingCreatePrestacionModalidadCiclica(true);
    setSuccessCreatePrestacionModalidadCiclica(false);
    setErrorCreatePrestacionModalidadCiclica(null);

    apiRecord.newSolicitudModalidadCiclica(userId, data)
      .then((res: any) => {
        setLoadingCreatePrestacionModalidadCiclica(false);
        setSuccessCreatePrestacionModalidadCiclica(true);
        setDataPrestacionModalidadCiclica(res.data);
        _cb?.(res.data);
      })
      .catch((err: any) => {
        console.log(err);
        setLoadingCreatePrestacionModalidadCiclica(false);
        setErrorCreatePrestacionModalidadCiclica(err.response?.data);
      });
  };

  return {
    createPrestacionModalidadCiclica,
    loadingCreatePrestacionModalidadCiclica,
    successCreatePrestacionModalidadCiclica,
    errorCreatePrestacionModalidadCiclica,
    dataCreatePrestacionModalidadCiclica
  };
};

export default useCreatePrestacionModalidadCiclica;
